<template>
  <div>
    <div v-if="!maitenance">
      <!-- login screen -->
      <div class="container-fluid" v-if="showLogin">
        <div class="row">
          <div
              class="col-sm-9 col-md-7 col-lg-4 mx-auto"
              style="margin-top: 50px"
          >
            <div class="card card-signin my-5 card-opacity">
              <div class="card-body">
                <img
                    class="mx-auto rounded mx-auto d-block logo-image"
                    alt="logoImage"
                    :src="logoImage"
                />

                <h5 class="card-title text-center text-join">ENTRAR</h5>
                <form
                    class="form-signin"
                    autocomplete="off"
                    @submit.prevent="authentication"
                >
                  <div class="form-label-group">
                    <label for="userLogin">Usuário</label>
                    <input
                        type="text"
                        id="userLogin"
                        class="form-control input-length"
                        v-bind:class="{
                      'is-invalid': error,
                    }"
                        placeholder="Digite seu usuário"
                        v-model="user"
                        required
                        autofocus
                    />
                    <span v-if="error" class="error">
                    Usuário e/ou Senha inválidos.
                  </span>
                  </div>
                  <br/>

                  <div class="form-label-group">
                    <label for="userPasswordLogin">Senha</label>

                    <div class="input-group input-length">
                      <input
                          :type="passwordFieldType"
                          v-model="password"
                          id="userPasswordLogin"
                          class="form-control input-length"
                          v-bind:class="{
                        'is-invalid': error,
                      }"
                          placeholder="Digite sua senha"
                          autocomplete="off"
                          required
                      />
                      <div class="input-group-append">
                        <button
                            id="visibilityPassword"
                            class="show-password"
                            type="button"
                            @click="switchVisibility"
                        >
                          <em
                              v-if="passwordFieldType === 'password'"
                              class="fa fa-eye"
                              style="cursos: pointer"
                          ></em>
                          <em
                              v-if="passwordFieldType === 'text'"
                              class="fa fa-eye-slash"
                              style="cursos: pointer"
                          ></em>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="access-center">
                    <button
                        class="btn btn-lg access"
                        id="sendLogin"
                        type="submit"
                    >
                      Acessar
                    </button>
                    <br/><br/>
                    <router-link
                        id="forgotPasswordLogin"
                        :to="{
                      name: 'RecoveryEmail',
                      query: { group: this.$route.params.group },
                    }"
                        class="forgot-pass"
                    >Esqueci minha senha
                    </router-link
                    >
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- login screen end -->
      <!-- wrong url -->
      <wrong-url v-if="showWrongUrl"></wrong-url>
    </div>

    <div class="container-fluid" v-if="maitenance">
      <div class="row">
        <div
            class="col-sm-9 col-md-7 col-lg-4 mx-auto"
            style="margin-top: 50px"
        >
          <div class="card card-signin my-5 ">
            <div class="card-body">
              <img
                  class="mx-auto rounded mx-auto d-block logo-image"
                  alt="logoImage"
                  :src="logoImage"
              />

              <h3 class="text-center text-danger mt-4">Sistema em Manutenção</h3>
              <h5 class="card-title text-center text-join">Desculpe pelo transtorno, estamos realizando melhorias. Por favor, tente novamente mais tarde.</h5>

            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import axios from "axios";
import Vue from "vue";
import WrongUrl from "../../../common/components/WrongUrl";

export default {
  name: "Login",
  components: { WrongUrl },
  data() {
    return {
      logoImage: "",
      user: "",
      password: "",
      passwordFieldType: "password",
      idGroup: "",
      error: false,
      showLogin: false,
      showWrongUrl: false,
      themeColor: "",
      maitenance: false
    };
  },

  methods: {
    authentication: function () {
      let user = this.user;
      let password = this.password;
      let grp_id = this.idGroup;

      this.$store
        .dispatch("login", { user, password, grp_id })
        .then(() => {
          if (this.$route.query.token) {
            axios
              .post(
                `${process.env.API_PBM}/user/firstAccess/relationship/${this.$route.query.token}`
              )
              .then((response) => {
                this.$router.push({ name: "home" });
              })
              .catch((err) => {
                Vue.$toast.error(
                  "Não foi possível vincular usuário ao sacado",
                  {
                    position: "top-right",
                    duration: 5000,
                  }
                );
              });
          } else {
            this.$router.push({ name: "home" });
          }
        })
        .catch((err) => {

          switch (err.response.status) {
            case 423:
              return Vue.$toast.error(err.response.data.message, {
                position: "top-right",
                duration: 5000,
              });
            case 426:
              Vue.$toast.error(err.response.data.message, {
                position: "top-right",
                duration: 5000,
              });
              return this.$router.push({
                name: 'RecoveryEmail',
                query: { group: this.$route.params.group },
              });
          }

          this.error = true;
        });
    },
    switchVisibility() {
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
    },
    checkIntegrationJWT: function () {
      let jwt = this.$route.query.jwt;

      if (jwt) {
        this.$store.dispatch("checkJWT", jwt).then(() => {
          this.$router.push({ name: "home" });
        });
      }
    },
  },

  mounted() {
    // Descomentar se quiser deixar o portal em manutenção
    // if (!Object.keys(this.$route.query).length || !this.$route.query.manutencao) {
      // this.maitenance = true;
    // }

    let group = this.$route.params.group;
    let successMessage = this.$route.query.success;

    if (successMessage) {
      Vue.$toast.success("Senha alterada com sucesso!", {
        position: "top-right",
        duration: 5000,
      });
    }
    localStorage.removeItem("userLogged");
    localStorage.setItem("group", group);
    axios
      .get(`${process.env.API_PBM}/group/${group}`)
      .then((response) => {
        this.showLogin = true;
        this.showWrongUrl = false;
        let background = response.data.data.background;
        let logo = response.data.data.logo;
        this.idGroup = response.data.data.id;
        this.themeColor = response.data.data.skin;

        localStorage.setItem("themeColor", this.themeColor);
        localStorage.setItem("logo", logo);
        localStorage.setItem("logoVazado", response.data.data.logo_vazado);

        if (background != null) {
          document.body.className = "background-login";
          document.body.style.backgroundImage = `url("${background}")`;
        }
        this.logoImage = logo != null ? logo : "";

        this.checkIntegrationJWT();
      })
      .catch((error) => {
        this.showLogin = false;
        this.showWrongUrl = true;
      });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.logo-image {
  width: 100%;
  max-width: 240px;
}

label {
  color: rgb(100, 95, 95);
}

.text-join {
  color: rgb(100, 95, 95);
  font-size: 20px;
  margin-top: 10px;
  font-size: 18px;
  margin-bottom: 20px;
}

.card-opacity {
  background: rgba(255, 255, 255, 0.8);
  border: none;
}

.input-length {
  margin: 0 auto;
  font-size: 15px;
}

.error {
  display: inline-block;
  font-size: 13px;
  color: #b0191a;
}

label {
  display: inline-block;
  font-size: 17px;
}
.show-password {
  height: 100%;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  background-color: transparent;
  position: absolute;
  width: 50px;
  z-index: 5;
  margin-left: -51px;
  margin-top: 1px;
}

.access {
  background-color: var(--colorDefault) ;
  color: #fff;
  width: 35%;
  margin-top: 15px;
  border-radius: 6px;
  cursor: pointer;
  padding: 5px;
  font-size: 17px;
}
.access:hover {
  background-color: var(--colorDefaultActiveHover);
}
.access-center {
  text-align: center;
}
.forgot-pass {
  color: #000000;
  font-weight: bold;
  text-decoration: none;
  margin-top: 5px;
  font-size: 15px;
}
.recaptcha-align {
  margin: 0 auto;
  display: inline-block;
}

label {
  color: rgb(100, 95, 95) !important;
}
@media only screen and (max-width: 900px) {
  .text-join {
    color: rgb(100, 95, 95);
    font-size: 20px;
  }

  .text-align-center {
    margin-top: 5px;
    margin-left: 33px;
    color: rgb(100, 95, 95);
    font-size: 14px;
  }
}
@media only screen and (min-width: 1340px) {
  /* styles for browsers larger than 1440px; */
}
@media only screen and (min-width: 1440px) {
  /* styles for browsers larger than 1440px; */
}

@media only screen and (max-width: 1940px) {
}

@media only screen and (min-width: 2000px) {
  /* for sumo sized (mac) screens */
}
</style>



// WEBPACK FOOTER //
// src/views/components/login/Login.vue